import { Grid, TextField, Button, Typography } from "@material-ui/core";
import { PrimaryButton } from "../components-atoms";
import GeneralModal from "./GeneralModal";
import { useState } from "react";

interface SubscriptionActivateModalProps {
	isVisible: boolean;
	close: () => void;
	addTranche: (numberOfCredits: number, price: number) => void;
}

export function SubscriptionAddTrancheModal({ isVisible, close, addTranche }: SubscriptionActivateModalProps): JSX.Element {
	const [numberOfCredits, setNumberOfCredits] = useState<string>("0");
	const [oneTimePrice, setOneTimePrice] = useState<string>("0.0");

	function isFloat(val: string) {
		var floatRegex = /^[0-9]+(\.)?[0-9]*$/;
		if (!floatRegex.test(val)) return false;
		if (isNaN(parseFloat(val))) return false;
		return true;
	}

	const hasInvalidCredits = parseInt(numberOfCredits) % 1 !== 0;
	const hasInvalidPrice = !isFloat(oneTimePrice) || parseFloat(oneTimePrice) < 0.0;

	return (
		<GeneralModal
			title="Add Delivery Tranche"
			description="Add a delivery tranche to this subscription."
			visible={isVisible}
			onClose={() => close()}
			onSubmit={() => { if (!hasInvalidPrice && !hasInvalidCredits) addTranche(parseInt(numberOfCredits), parseFloat(oneTimePrice)); }}
			modalWidth="560px"
		>
			<GeneralModal.ContentArea>
				<Grid container>
					<Grid item xs={12}>
						<TextField
							fullWidth
							variant="outlined"
							margin="normal"
							id="NrOfFreeDeliveries"
							placeholder="Number of free deliveries"
							label="Number of free deliveries"
							name="CategoryName"
							value={numberOfCredits}
							onChange={v => setNumberOfCredits(v.target.value)}
						/>
					</Grid>
					{hasInvalidCredits && <Grid item xs={12}>
						<Typography variant="caption" color="error">
							Please enter a valid integer for credit amount.
						</Typography>
					</Grid>}
					<Grid item xs={12}>
						<TextField
							fullWidth
							variant="outlined"
							margin="normal"
							id="Price"
							placeholder="Price"
							label="Price"
							name="Price"
							value={oneTimePrice}
							onChange={v => setOneTimePrice(v.target.value)}
							error={hasInvalidPrice}
						/>
					</Grid>
					{hasInvalidPrice && <Grid item xs={12}>
						<Typography variant="caption" color="error">
							Please enter a valid price.
						</Typography>
					</Grid>}
				</Grid>
			</GeneralModal.ContentArea>
			<GeneralModal.ButtonArea>
				<Button
					onClick={() => close()}>
					<Typography
						variant="button"
						component="p"
						color="primary"
					>
						Cancel
					</Typography>
				</Button>
				<PrimaryButton
					title="Activate"
					onClick={() => { if (!hasInvalidPrice && !hasInvalidCredits) addTranche(parseInt(numberOfCredits), parseFloat(oneTimePrice)); }}
					disabled={hasInvalidPrice}
				/>
			</GeneralModal.ButtonArea>
		</GeneralModal>
	);
}
